import { useStore } from '../store';

export function usePermissions(projectsA = null) {
   const { user, activeProject, projects } = useStore();
   const actproject = projectsA ? projects.find(item => item._id === projectsA._id || item._id === projectsA) : activeProject;

   // Иерархия ролей проекта
   const roleOrder = ['viewer', 'member', 'admin', 'owner'];

   const normalizeRole = (role) => {
      return roleOrder.includes(role) ? role : 'viewer';
   };

   const isRoleAtLeast = (actual, required) => {
      const actualIdx = roleOrder.indexOf(normalizeRole(actual));
      const requiredIdx = roleOrder.indexOf(normalizeRole(required));
      return actualIdx >= requiredIdx;
   };

   const getUserProjectRole = (project) => {
      if (!project || !user?._id) return null;
      const uid = user._id.toString();

      // Владелец проекта
      if (project.owner?.toString?.() === uid || project.owner === uid) {
         return 'owner';
      }

      // Участник проекта
      const member = (project.members || []).find(
         m => m.user?._id?.toString?.() === uid || m.user?._id === uid
      );
      if (member) {
         return normalizeRole(member.role);
      }

      return null;
   };

   const getCurrentRole = () => {
      if (!actproject) return null;
      return getUserProjectRole(actproject);
   };

   const canProjectAdmin = (project = actproject) => {
      const role = getUserProjectRole(project);
      return role && isRoleAtLeast(role, 'admin');
   };

   const canProjectEdit = (project = actproject) => {
      const role = getUserProjectRole(project);
      return role && isRoleAtLeast(role, 'admin');
   };

   const canProjectManageMembers = (project = actproject) => {
      const role = getUserProjectRole(project);
      return role === 'owner' || role === 'admin';
   };

   const canCreateTask = (project = actproject) => {
      const role = getUserProjectRole(project);
      return role && isRoleAtLeast(role, 'member');
   };

   const canEditTask = (project = actproject) => {
      const role = getUserProjectRole(project);
      return role && isRoleAtLeast(role, 'member');
   };

   const canDeleteTask = (project = actproject) => {
      const role = getUserProjectRole(project);
      return role && isRoleAtLeast(role, 'admin');
   };

   const canComment = (project = actproject) => {
      const role = getUserProjectRole(project);
      // Viewer может только комментировать
      return role && isRoleAtLeast(role, 'viewer');
   };

   const canViewProject = (project = actproject) => {
      const role = getUserProjectRole(project);
      return role !== null;
   };

   const canCreateProject = () => {
      return !!user; // Any authenticated user can create projects
   };

   const canDeleteProject = (project = actproject) => {
      const role = getUserProjectRole(project);
      return role === 'owner';
   };

   const getPermissionReason = (permission) => {
      const reasons = {
         canProjectManageMembers: 'Требуется роль администратора или выше',
         canCreateTask: 'Требуется роль участника или выше',
         canEditTask: 'Требуется роль участника или выше',
         canDeleteTask: 'Требуется роль администратора или выше',
         canProjectEdit: 'Требуется роль администратора или выше',
         canDeleteProject: 'Требуется роль владельца',
      };
      return reasons[permission] || 'Недостаточно прав';
   };

   return {
      user,
      actproject,
      getCurrentRole,
      canProjectAdmin,
      canProjectEdit,
      canProjectManageMembers,
      canCreateTask,
      canEditTask,
      canDeleteTask,
      canComment,
      canViewProject,
      canCreateProject,
      canDeleteProject,
      getPermissionReason,
      isRoleAtLeast,
      getUserProjectRole,
   };
}
